import { Link } from 'react-router-dom';
import { FiShieldOff } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { ROLE_HOME_ROUTE } from '../models/roles';

export default function UnauthorizedView() {
  const { user } = useAuth();
  const home = user ? ROLE_HOME_ROUTE[user.role] : '/login';

  return (
    <div className="status-view">
      <div className="status-view__icon">
        <FiShieldOff />
      </div>
      <h1>Acceso no autorizado</h1>
      <p>Tu rol no tiene permisos para ver esta sección.</p>
      <Link to={home} className="btn btn-primary">
        Volver a mi inicio
      </Link>
    </div>
  );
}
